import {  internal, template, AttributeMarshallingMixin, ReactiveElement } from '../vendor/elix.js';

const sportIdsByName = {
  swim: 1,
  bike: 2,
  run: 3,
  brick: 4,
  crosstrain: 5,
  rest: 7,
  mountainbike: 8,
  strength: 9,
  custom: 10,
  xcski: 11,
  rowing: 12,
  walk: 13,
  other: 100
};

const sportNamesById = {};
Object.entries(sportIdsByName)
  .forEach((pair) => {
    let [name, id] = pair;
    sportNamesById[id] = name;
  });

const validNames = Object.keys(sportIdsByName);
const validIds = Object.values(sportIdsByName);

class TpSportIcon extends AttributeMarshallingMixin(ReactiveElement) {

  get colored() {
    return this[internal.state].colored;
  }

  set colored(colored) {
    const isColored = colored === true || colored === 'true' || this.hasAttribute('colored');
    this[internal.setState]({ colored: isColored });
  }

  get sportId() {
    return sportIdsByName[this.sportName];
  }

  set sportId(sportId) {
    if (!validIds.includes(parseInt(sportId))) {
      throw new Error(`Invalid sport id ${sportId} for tp-sport-type-icon. Sport id must be one of (${validIds.join(', ')})`);
    }
    this.sportName = sportNamesById[sportId];
  }

  get sportName() {
    return this[internal.state].sportName;
  }

  set sportName(sportName = '') {
    sportName = sportName.toLowerCase().replace(/[^a-z]/g,'');
    if (!validNames.includes(sportName)) {
      throw new Error(`Invalid sport name ${sportName} for tp-sport-type-icon. Sport name must be one of (${validNames.join(', ')})`);
    }
    this[internal.setState]({ sportName });
  }

  get [internal.defaultState]() {
    return Object.assign(
      {},
      super[internal.defaultState],
      { sportName: 'other' }
    );
  }

  [internal.render](changed) {
    super[internal.render](changed);
    const icon = this[internal.ids].icon;
    icon.className = this.colored ? `${this.sportName} colored` : this.sportName;
  }

  get [internal.template]() {
    return template.html`

      <i id='icon' class='other'></i>
      
      <style>

        :host {
          display: inline-block;
          height: 1em;
          width: 1em;
        }

        i {
          display:inline-block;
          font-family:"tp-sport-type-icon";
          font-style:normal;
          font-weight:normal;
          height: 1em;
          line-height:1;
          overflow: hidden;
          position: relative;
          speak:none;
          text-decoration:inherit;
          text-rendering:auto;
          text-transform:none;
          width: 1em;
          -webkit-font-smoothing:antialiased;
          -moz-osx-font-smoothing:grayscale;
        }

        i:before {
          display: inline-block;
          font-size: 1.2em;
          left: -0.1em;
          position: relative;
          top: -0.1em;
        }

        i.swim:before {
          content:"\\f110";
        }

        i.bike:before {
          content:"\\f101";
        }

        i.run:before {
          content:"\\f10e";
        }

        i.brick:before {
          content:"\\f102";
        }

        i.crosstrain:before {
          content:"\\f10a";
        }

        i.rest:before {
          content:"\\f10c";
        }

        i.mountainbike:before {
          content:"\\f109";
        }

        i.strength:before {
          content:"\\f10f";
        }

        i.custom:before {
          content:"\\f10a";
        }

        i.xcski:before {
          content:"\\f112";
        }

        i.rowing:before {
          content:"\\f10d";
        }

        i.walk:before {
          content:"\\f111";
        }

        i.other:before {
          content:"\\f10a";
        }

        i.swim.colored {
          color: var(--tp-color-sport-swim);
        }

        i.bike.colored {
          color: var(--tp-color-sport-bike);
        }

        i.run.colored {
          color: var(--tp-color-sport-run);
        }

        i.brick.colored {
          color: var(--tp-color-sport-brick);
        }

        i.crosstrain.colored {
          color: var(--tp-color-sport-crosstrain);
        }

        i.rest.colored {
          color: var(--tp-color-sport-rest);
        }

        i.mountainbike.colored {
          color: var(--tp-color-sport-mountainbike);
        }

        i.strength.colored {
          color: var(--tp-color-sport-strength);
        }

        i.custom.colored {
          color: var(--tp-color-sport-custom);
        }

        i.xcski.colored {
          color: var(--tp-color-sport-xcski);
        }

        i.rowing.colored {
          color: var(--tp-color-sport-rowing);
        }

        i.walk.colored {
          color: var(--tp-color-sport-walk);
        }

        i.other.colored {
          color: var(--tp-color-sport-other);
        }

      </style>
    `;
  }
}

export default TpSportIcon;
